const initialState = () => ({
  padId: null,
  isOpened: false,
  error: null
});

const ACTION_KEY = 'PROFESSIONAL_PRESCRIBER_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const newData = action.payload;
      return {
        ...state,
        isOpened: true,
        padId: newData.padId
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
